import React from 'react';
import { FaPhone, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import darkLogo from './../../assets/logos_icons/pharmrx_logo_grey.png';
import './NewFooter.css';

const NewFooter = () => {
  return (
    <div>
      <footer className="new-footer">
        <div className="new-footer-container">
          <div className="new-footer-logo-section">
            <img className="new-footer-logo" src={darkLogo} alt="Company Logo" />
            <div className="new-footer-social">
              <a 
                href="https://www.linkedin.com/company/pharm-rx-chemical-corp" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="link-linkedin" 
                aria-label="Visit our LinkedIn profile"
              >
                <FaLinkedin />
              </a>
              <a 
                href="mailto:info@pharm-rxchem.com" 
                className="link-email" 
                aria-label="Send us an email"
              >
                <FaEnvelope />
              </a>
              <a 
                href="tel:+9739171400" 
                className="link-phone" 
                aria-label="Call us at (973) 917-1400"
              >
                <FaPhone />
              </a>
            </div>
          </div>
          <div className="new-footer-links">
            <div className="new-footer-column">
              <p>Quick Links</p>
              <ul className="nav-links">
                <li><a href="/about">About Us</a></li>
                <li><a href="/contact">Contact</a></li>
                <li><a href="/faq">FAQ</a></li>
                <li><a href="/events">Events</a></li>
              </ul>
            </div>
            <div className="new-footer-column">
              <p>Products</p>
              <ul className="nav-links">
                <li><a href="https://www.pharm-rx.store/products" target="_blank" rel="noopener noreferrer">All products</a></li>
                <li><a href="https://www.pharm-rx.store/products?category=technologies-pharmaceuticals-nutraceuticals-apis-and-raw-materials">Pharmaceutical Actives</a></li>
                <li><a href="https://www.pharm-rx.store/products?category=technologies-pharmaceuticals-nutraceuticals-nutraceutical-ingredients">Nutraceuticals</a></li>
                <li><a href="https://www.pharm-rx.store/products?category=technologies-food-ingredients">Food Ingredients</a></li>
                <li><a href="https://www.pharm-rx.store/products?category=technologies-cosmetic-ingredients">Cosmetic Ingredients</a></li>
              </ul>
            </div>
            <div className="new-footer-column">
              <p>Company</p>
              <ul className="nav-links">
                <li><a href="/about">Who We Are</a></li>
                <li><a href="/about#our-story">Our Story</a></li>
                <li><a href="/privacy-policy">Privacy Policy</a></li>
                <li><a href="/terms-of-use">Terms of Use</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className="new-footer-bottom">
        <div className="new-footer-bottom-container">
          <p className="new-footer-copyright">
            © 2016-{new Date().getFullYear()} Pharm-Rx Chemical Corporation. All rights reserved.
          </p>
          <div className="new-footer-legal-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <span>|</span>
            <a href="/terms-of-use">Terms of Use</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewFooter;
